import styled, { css } from 'styled-components'

export const SC_Embed = styled.div.attrs(props => ({
	className: "embed-responsive embed-responsive-16by9",
}))`
	border-radius: ${props => props.theme.borderRadius};
`

export const SC_Iframe = styled.iframe.attrs(props => ({
	className: "embed-responsive-item animated fadeIn delay-1s",
	allowFullScreen: 1,
	frameborder: 0,
	modestbranding: 1,
	allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
}))`

`

